/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Backoffice API Gateway
 * OpenAPI spec version: 1.0.0
 */

export type EstimateMeterReadRequestFuelType =
  (typeof EstimateMeterReadRequestFuelType)[keyof typeof EstimateMeterReadRequestFuelType]

export const EstimateMeterReadRequestFuelType = {
  ELECTRICITY: "ELECTRICITY",
  GAS: "GAS",
} as const
